import { permissionAreaKeyNameOf } from "../../../helpers/permission.helpers";
import { WorkQueueArea } from "../../../models/roles/role-accesses/work-queue-area";
import { MenuMainNode } from "./nodes";

export function entityKeyResolver<T extends WorkQueueArea>(name: Extract<keyof T, string>): string { return name; };

export const workQueueMenu: MenuMainNode = {
    icon: 'workQueuesIconTemplate',
    title: 'Menu.WorkQueues.Name',
    link:'/work-queues',
    rootPath: '/work-queues',    
    areaPermissionKey: permissionAreaKeyNameOf('workQueue'),    
    children: [
        {
            abbreviation: "Unassigned",            
            isVisible: true,
            link: "/work-queues/unassigned",
            title: "Unassigned",
            entityPermissionKey: entityKeyResolver('workQueues')
        }
    ]
}